export default __webpack_public_path__ + "static/media/00.8fe7f9c4.png";